var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { format } from "date-fns";
const stripTrailingSlash = (str) => str.charAt(str.length - 1) == "/" ? str.substr(0, str.length - 1) : str;
const urlUtils = (url, queryParams) => {
    // if (process.env.NODE_ENV !== 'development') {
    //     return `${stripTrailingSlash(url)}.json`;
    // }
    return url + (queryParams || '');
};
const defaultDateFormat = "dd-mm-yy";
const inputNumberProps = {
    maxFractionDigits: 3,
    locale: "en-IN"
};
const formatDate = (value, dFormat) => {
    try {
        return value ? `${format(new Date(value), dFormat || "dd-MM-yyyy")}` : "";
    }
    catch (error) {
        return value;
    }
};
const refactorDate = (value) => {
    try {
        const [day, month, year] = value.split('-').map(Number);
        const dateObj = new Date(year, month - 1, day);
        return dateObj;
    }
    catch (error) {
        console.log("error ::", error);
        return value;
    }
};
const formatCurrency = (value) => {
    var _a;
    return !!value ? (_a = parseInt(value)) === null || _a === void 0 ? void 0 : _a.toLocaleString(undefined, { style: 'currency', currency: 'INR' }) : "NA";
};
const formatNumber = (value) => {
    var _a;
    return value ? (_a = parseInt(value)) === null || _a === void 0 ? void 0 : _a.toLocaleString(undefined, { maximumFractionDigits: 2 }) : 0;
};
const base64Converter = (file) => new Promise((resolve, reject) => {
    if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var _a;
            let result = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString();
            resolve(result);
        };
        reader.onerror = error => {
            reject(error);
        };
    }
    else {
        resolve("");
    }
});
const shouldAllowAdd = (items) => {
    if (items.length === 0)
        return true;
    let temp = items[items.length - 1];
    return (temp === null || temp === void 0 ? void 0 : temp.item_key) &&
        (temp === null || temp === void 0 ? void 0 : temp.itemuom_key);
};
const convertDateValue = (value, reverse) => {
    if (value) {
        return reverse ? `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}` : new Date(value);
    }
    return value;
};
// const formatDate = (value: any, reverse?: boolean) => {
//     if (!value) return value;
//     console.log("value received::", value, reverse);
//     console.log("type of value received::", typeof(value), typeof(reverse));
//     let dateObj: Date;
//     if (reverse) {
//         // Convert Date object to yyyy-m-d
//         const toBeReturned = `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`;
//         console.log('returning value', toBeReturned);
//         return toBeReturned;
//     }
//     if (typeof value === 'string') {
//         // Handle dd-mm-yyyy and yyyy-m-d
//         if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
//             const [day, month, year] = value.split('-').map(Number);
//             dateObj = new Date(year, month - 1, day);
//         } else if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(value)) {
//             // yyyy-m-d (new Date can parse this correctly)
//             dateObj = new Date(value);
//         } else {
//             console.warn("Unknown date format");
//             dateObj = new Date(value); // Fallback
//         }
//     } else {
//         dateObj = new Date(value);
//     }
//     console.log('returning value', dateObj);
//     return dateObj;
// };
const getMonthsFor = (year) => {
    if (!year) {
        return [];
    }
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const allMonths = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthsArray = allMonths.map((month, index) => ({
        name: month,
        value: index + 1 // Month index + 1 for 1-based month numbers
    }));
    if (year === currentYear) {
        return monthsArray.slice(0, currentMonth + 1);
    }
    else {
        return monthsArray;
    }
};
const getPreviousYears = (value) => {
    if (!value)
        return [];
    const currentYear = new Date().getFullYear();
    const lastYears = [];
    for (let i = 0; i < value; i++) {
        lastYears.push(currentYear - i);
    }
    return lastYears;
};
const tdsDropdownOptions = (event, setState, options) => {
    const filtered = options || [1, 2, 3].filter(item => item.toString().includes(event.query));
    setState(filtered);
};
function adjustNumber(value, action) {
    let roundedValue, difference;
    if (action === 'A') {
        roundedValue = Math.ceil(value);
        difference = parseFloat((roundedValue - value).toFixed(2));
        return {
            rounded: roundedValue.toFixed(2),
            remainder: difference
        };
    }
    else if (action === 'S') {
        roundedValue = Math.floor(value);
        difference = parseFloat((value - roundedValue).toFixed(2));
        return {
            rounded: roundedValue.toFixed(2),
            remainder: difference
        };
    }
    else {
        return {
            rounded: value === null || value === void 0 ? void 0 : value.toFixed(2),
            remainder: 0
        };
    }
}
// Helper to reverse date string from dd-mm-yyyy to yyyy-mm-dd
const reverseDate = (dateStr) => {
    const parts = dateStr === null || dateStr === void 0 ? void 0 : dateStr.split("-");
    if ((parts === null || parts === void 0 ? void 0 : parts.length) === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`; // yyyy-mm-dd
    }
    return dateStr; // return as-is if format is unexpected
};
const updateDateFormate = (data, dateKey) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("data for the date change function ::", data, "dateKey ::", dateKey);
    if (!Array.isArray(data))
        return [];
    return data.map(item => {
        // Clone the object to avoid mutating a read-only one
        const newItem = Object.assign({}, item);
        if (item === null || item === void 0 ? void 0 : item.visit_date) {
            console.log("visit_date ::", item.visit_date);
            newItem.visit_date = reverseDate(item.visit_date);
        }
        else if (item === null || item === void 0 ? void 0 : item.last_followup_date) {
            let followUpDate = item.last_followup_date;
            console.log("last_followup_date ::", followUpDate);
            newItem.last_followup_date = reverseDate(followUpDate);
        }
        console.log("newItem ::", newItem);
        return newItem;
    });
});
const cleanDecimal = (value) => {
    const decimalPart = value.toString().split(".")[1];
    if (decimalPart && decimalPart.length > 2) {
        return parseFloat(value.toFixed(2));
    }
    return value;
};
export { urlUtils, formatDate, formatCurrency, formatNumber, base64Converter, shouldAllowAdd, convertDateValue, getMonthsFor, getPreviousYears, defaultDateFormat, inputNumberProps, tdsDropdownOptions, adjustNumber, updateDateFormate, cleanDecimal, reverseDate, refactorDate };
